module.exports = __webpack_public_path__ + "static/img/12.bf54dc8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/2/zh/12.png
// module id = HQH+
// module chunks = 0